import {request} from "./request";

// 查询小程序信息
export function getAppletsInfo() {
    return request({
        url: '/hkt/applets/get_applets_info',
        params: {

        }
    })
}

// 获取小程序授权链接
export function getAppletsAuthUrl(url) {
    return request({
        url: '/hkt/applets/get_applets_auth_url',
        params: {
            url
        }
    })
}

// 设置小程序授权信息
export function setAppletsAuthInfo(authorization_code) {
    return request({
        url: '/hkt/applets/set_applets_auth_info',
        params: {
            authorization_code
        }
    })
}

// 发布小程序
export function releaseApplets() {
    return request({
        url: '/hkt/applets/release_applets',
        params: {

        }
    })
}